import React, { useRef } from 'react';
import { AgendaTitle } from './AgendaTitle';
import { AgendaView } from './AgendaView';
import { Tab } from './types';

import { INFINITE } from '../../../Agenda/constants';

export const AgendaDrawerContent = ({ tabs }: { tabs: Tab[] }) => {
    const agendaTabsRef = useRef<HTMLDivElement>(null);
    return (
        <div>
            <AgendaTitle tabRef={agendaTabsRef} />
            <AgendaView
                tabs={tabs}
                maxSlots={INFINITE}
                agendaTabsRef={agendaTabsRef}
            />
        </div>
    );
};
